import { BoundingSphere, Cartesian2, Cartesian3, Color, VerticalOrigin, Viewer, ScreenSpaceEventHandler, ScreenSpaceEventType, defined, Cartographic, Math as MathCesium, LabelStyle } from "cesium";
import locationPin from '../assets/images/location-pin.png'
import locationPickPin from '../assets/images/location-pin-pick.png'
import { getMessage } from "../language";
// let locationPin = 'https://unpkg.com/beta-test-view@0.0.10/dist/assets/images/location-pin.png'

export class FlyLocation {
    viewer: Viewer;
    containerId: string;
    treeView: any = []

    constructor(containerId: string, viewer: any, treeTileModel?: any) {
        this.containerId = containerId; // Gán giá trị containerId    
        this.viewer = viewer;//Gán giá trị viewer
        this.treeView = treeTileModel
    }
    // ██       ██████   ██████  █████  ████████ ██  ██████  ███    ██ 
    // ██      ██    ██ ██      ██   ██    ██    ██ ██    ██ ████   ██ 
    // ██      ██    ██ ██      ███████    ██    ██ ██    ██ ██ ██  ██ 
    // ██      ██    ██ ██      ██   ██    ██    ██ ██    ██ ██  ██ ██ 
    // ███████  ██████   ██████ ██   ██    ██    ██  ██████  ██   ████ 
    pointCurrentLocationWeb: any;
    private _locationPickPinEntity: any = null;
    private _pickPinHandler: ScreenSpaceEventHandler | null = null;
    private _pickCallback: ((data: { longitude: number; latitude: number } | null) => void) | undefined;

    /**
     * Hàm xử lý hành động bay đến vị trí hiện tại
     */
    flyToCurrentLocation = () => {
        return new Promise((resolve, reject) => {

            if (this.pointCurrentLocationWeb) {
                this.viewer.entities.remove(this.pointCurrentLocationWeb);
                this.pointCurrentLocationWeb = null;
            }




            if (this._locationPickPinEntity) {
                this.viewer.entities.remove(this._locationPickPinEntity);
                this._locationPickPinEntity = null;
            }

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const latitude = position.coords.latitude;
                        const longitude = position.coords.longitude;
                        // Thêm entity tại vị trí hiện tại với biểu tượng từ URL trực tuyến
                        this.pointCurrentLocationWeb = this.viewer.entities.add({
                            id: "your-location-marker",
                            position: Cartesian3.fromDegrees(longitude, latitude),
                            billboard: {
                                image: locationPin, // URL trực tuyến cho icon
                                width: 40, // Chiều rộng của icon
                                height: 40, // Chiều cao của icon
                                disableDepthTestDistance: Number.POSITIVE_INFINITY,
                                verticalOrigin: VerticalOrigin.BOTTOM, // Căn chỉnh ở đáy để trỏ chính xác vào vị trí

                            },
                            label: {
                                text: getMessage('your-location'),
                                font: "14pt sans-serif",
                                verticalOrigin: VerticalOrigin.TOP,
                                showBackground: true,
                                backgroundColor: new Color(0.0, 0.0, 0.0, 0.3), // Màu nền đen với độ trong suốt // Nền màu đỏ
                                pixelOffset: new Cartesian2(0, -70), // Đẩy nhãn lên phía trên icon
                                disableDepthTestDistance: Number.POSITIVE_INFINITY,
                            },
                        });

                        // Fly camera tới vị trí hiện tại
                        this.viewer.camera.flyTo({
                            destination: Cartesian3.fromDegrees(longitude, latitude, 1000.0),

                            complete: function () {
                                resolve("Fly to location complete and centered");

                            },
                        });

                    },
                    (error) => {
                        console.error("Error getting location: ", error);
                        reject(error);
                    }
                );
            } else {
                reject("Geolocation is not supported by this browser.");
            }
        });
    }



    private _isSetLocationHome: boolean = false
    longitudeHomeLocation: number = 105.83584048801437
    latitudeHomeLocation: number = 10.53777232222561

    heightHomeLocation: number = 1000
    angleHomeLocation: number = 0
    pitchHomeLocation: number = 0
    durationHomeLocation: number = 2


    /**
     * Thiết lập vị trí home với các tham số được chỉ định.
     *
     * @param location - Một đối tượng chứa thông tin chi tiết về vị trí.
     * @param location.longitude - Kinh độ của vị trí home.
     * @param location.latitude - Vĩ độ của vị trí home.
     * @param location.height - Độ cao của vị trí nhà (tùy chọn, mặc định là 1000).
     * @param location.angle - Góc của vị trí home (tùy chọn, mặc định là 0).
     * @param location.pitch - Độ nghiêng của vị trí home (tùy chọn, mặc định là 0).
     * @param location.duration - Thời gian cho hiệu ứng bay đến vị trí (tùy chọn, mặc định là 2).
     */
    setLocationHome = (location: {
        longitude: number;
        latitude: number;
        height?: number;
        angle?: number;
        pitch?: number;
        duration?: number
    }) => {
        this._isSetLocationHome = true;
        this.longitudeHomeLocation = location.longitude;
        this.latitudeHomeLocation = location.latitude;
        this.heightHomeLocation = location.height || 1000;
        this.angleHomeLocation = location.angle || 0;
        this.pitchHomeLocation = location.pitch || 0;
        this.durationHomeLocation = location.duration ? location.duration : 2
    }




    /**
     * Hàm xử lý hành động bay đến vị trí công trường  
     */
    flyToHomeLocation = () => {
        if (!this._isSetLocationHome) {
            if (this.treeView.length != this._countTreeView) {

                this._getCombinedBoundingBox()
            } else {

                if (this._combinedBoundingSphere) {
                    this.viewer.camera.flyToBoundingSphere(this._combinedBoundingSphere, {
                        duration: 2
                    })
                }
            }
        } else {

            this.viewer.camera.flyTo({
                destination: Cartesian3.fromDegrees(this.longitudeHomeLocation, this.latitudeHomeLocation, this.heightHomeLocation),

                duration: this.durationHomeLocation, // thời gian zoom tới vị trí này (tính bằng giây)
                complete: () => {
                    if (this.angleHomeLocation !== 0 && this.pitchHomeLocation !== 0) {
                        this.viewer.camera.setView({
                            orientation: {
                                heading: this.angleHomeLocation, // Độ nghiêng của camera (heading)
                                pitch: this.pitchHomeLocation, // Độ cao của camera (pitch)
                                roll: 0 // Góc xoay của camera (roll)
                            }
                        })
                    }
                }
            });
        }
    }

    /**
     * Hàm bay đến vị trí mong muốn riêng
     *  @param {number} longitude kinh độ
     * @param {number} latitude  vĩ độ
     * @param {number} height  độ cao
     * @param {number} duration  thời gian bay
     */
    flyToLocation = (longitude: number, latitude: number, height: number = 1000, duration: number = 2) => {
        this.viewer.camera.flyTo({
            destination: Cartesian3.fromDegrees(longitude, latitude, height),
            duration: duration // thời gian zoom tới vị trí này (tính bằng giây)
        });
    }

    private _countTreeView: number = 0
    private _combinedBoundingSphere: BoundingSphere | undefined
    private _getCombinedBoundingBox = () => {
        this._countTreeView = this.treeView.length
        let boundingVolumes: BoundingSphere[] = [];
        this.treeView.forEach((tileModel: any) => {

            // Kiểm tra nếu tileModel.tileset và tileModel.tileset.boundingSphere tồn tại
            if (tileModel.tileset && tileModel.tileset.boundingSphere && tileModel.isShow) {
                const boundingVolume = tileModel.tileset.boundingSphere;
                boundingVolumes.push(boundingVolume); // Nếu có, thêm vào mảng boundingVolumes
            }
        })
        if (boundingVolumes.length == 0) return null
        // Khởi tạo điểm min và max ban đầu
        let combinedMin: Cartesian3 = new Cartesian3(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY);
        let combinedMax: Cartesian3 = new Cartesian3(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY);

        // Lặp qua tất cả các bounding volumes để tính toán min/max
        boundingVolumes.forEach((boundingVolume) => {
            const center = boundingVolume.center;
            const radius = boundingVolume.radius;

            // Tính toán các điểm cực trị (min, max) cho từng BoundingSphere
            const volumeMin = new Cartesian3(center.x - radius, center.y - radius, center.z - radius);
            const volumeMax = new Cartesian3(center.x + radius, center.y + radius, center.z + radius);

            // Cập nhật điểm min và max chung
            combinedMin = new Cartesian3(
                Math.min(combinedMin.x, volumeMin.x),
                Math.min(combinedMin.y, volumeMin.y),
                Math.min(combinedMin.z, volumeMin.z)
            );

            combinedMax = new Cartesian3(
                Math.max(combinedMax.x, volumeMax.x),
                Math.max(combinedMax.y, volumeMax.y),
                Math.max(combinedMax.z, volumeMax.z)
            );
        });
        if (combinedMin && combinedMax) {
            // Tạo BoundingSphere từ min và max
            const center = new Cartesian3(
                (combinedMin.x + combinedMax.x) / 2,
                (combinedMin.y + combinedMax.y) / 2,
                (combinedMin.z + combinedMax.z) / 2
            );

            const radius = Cartesian3.distance(combinedMin, combinedMax) / 2;
            this._combinedBoundingSphere = new BoundingSphere(center, radius);


            this.viewer.camera.flyToBoundingSphere(this._combinedBoundingSphere, {
                duration: 2
            })

        } else {
            return
        }
    }

    /**
     * Hàm xóa điểm pick hiện tại
     */
    removePickPin = () => {
        // remove stored pick entity if present
        if (this._locationPickPinEntity) {
            this.viewer.entities.remove(this._locationPickPinEntity);
            this._locationPickPinEntity = null;
        }

        // also remove by id in case it's present
        const pinById = this.viewer.entities.getById("pin-location-marker");
        if (pinById) {
            this.viewer.entities.remove(pinById);
        }

        // remove stored current location entity
        if (this.pointCurrentLocationWeb) {
            this.viewer.entities.remove(this.pointCurrentLocationWeb);
            this.pointCurrentLocationWeb = null;
        }

        // also remove by id for the current-location marker
        const yourById = this.viewer.entities.getById("your-location-marker");
        if (yourById) {
            this.viewer.entities.remove(yourById);
        }

        if (this._pickCallback) this._pickCallback(null);
    }

    // Đăng ký callback để trả dữ liệu khi chọn điểm
    callBackLocationPick = (callback: (data: { longitude: number; latitude: number } | null) => void) => {
        this._pickCallback = callback;
    }

    /**
     * Hàm dùng chuột pick lấy về long lat tại điểm pick.
     * Có hiệu ứng preview khi di chuyển chuột (move pick).
     */
    /**
     * Hàm dùng chuột pick lấy về long lat tại điểm pick.
     */
    locationPickPin = (callback?: (data: { longitude: number; latitude: number } | null) => void) => {
        // Nếu callback được truyền vào, lưu lại để gọi khi pick
        if (callback) this._pickCallback = callback;
        const LABEL_ID = "pin-location-marker";
        // Nếu đã có handler cũ, xóa bỏ trước khi tạo mới
        if (this._pickPinHandler) {
            this._pickPinHandler.destroy();
            this._pickPinHandler = null;
        }



        this._pickPinHandler = new ScreenSpaceEventHandler(this.viewer.canvas);
        let isLeftDragging = false;
        let startPos: Cartesian2 | undefined;

        // Bắt đầu click hoặc drag chuột trái
        this._pickPinHandler.setInputAction((movement: any) => {
            isLeftDragging = true;
            startPos = movement.position;
        }, ScreenSpaceEventType.LEFT_DOWN);

        // Phát hiện drag (di chuyển bản đồ) để xóa pin
        this._pickPinHandler.setInputAction((movement: any) => {
            if (isLeftDragging) {
                const currentPos = movement.endPosition;
                if (startPos && Cartesian2.distance(startPos, currentPos) > 5) {
                    this.removePickPin();
                }
            }
        }, ScreenSpaceEventType.MOUSE_MOVE);

        // Kết thúc click hoặc drag
        this._pickPinHandler.setInputAction(() => {
            isLeftDragging = false;
            startPos = undefined;
        }, ScreenSpaceEventType.LEFT_UP);

        // Sự kiện click để chọn điểm cố định (Toggle logic)
        this._pickPinHandler.setInputAction((click: any) => {
            // Nếu đã có pin rồi thì xóa đi và không làm gì cả (Toggle Off)
            if (this._locationPickPinEntity) {
                this.removePickPin();
                return;
            }
            const existingYour = this.viewer.entities.getById("your-location-marker");
            if (existingYour) {
                this.viewer.entities.remove(existingYour);
            }

            let cartesian: any = this.viewer.scene.pickPosition(click.position);

            if (!defined(cartesian)) {
                let ray = this.viewer.camera.getPickRay(click.position);
                if (defined(ray)) {
                    cartesian = this.viewer.scene.globe.pick(ray, this.viewer.scene);
                }
            }

            if (defined(cartesian)) {
                const pickedPosition = cartesian as Cartesian3;
                let cartographic = Cartographic.fromCartesian(pickedPosition);
                let longitude = MathCesium.toDegrees(cartographic.longitude);
                let latitude = MathCesium.toDegrees(cartographic.latitude);

                // Nếu đang hiển thị điểm current location thì xóa nó trước khi thêm pin pick
                if (this.pointCurrentLocationWeb) {
                    this.viewer.entities.remove(this.pointCurrentLocationWeb);
                    this.pointCurrentLocationWeb = null;
                }

                // Thêm pin cố định tại điểm đã chọn
                this._locationPickPinEntity = this.viewer.entities.add({
                    id: LABEL_ID,
                    position: pickedPosition,
                    billboard: {
                        image: locationPickPin,
                        width: 30,
                        height: 30,
                        verticalOrigin: VerticalOrigin.BOTTOM,
                        disableDepthTestDistance: Number.POSITIVE_INFINITY
                    },
                    label: {
                        text: `${getMessage("footer-longitude")}: ${longitude.toFixed(4)}, ${getMessage("footer-latitude")}: ${latitude.toFixed(4)}`,
                        font: "12pt sans-serif",
                        style: LabelStyle.FILL_AND_OUTLINE,
                        outlineWidth: 2,
                        verticalOrigin: VerticalOrigin.TOP,
                        pixelOffset: new Cartesian2(0, -60),
                        disableDepthTestDistance: Number.POSITIVE_INFINITY,
                        showBackground: true,
                        backgroundColor: new Color(0, 0, 0, 0.7)
                    }
                });

                if (this._pickCallback) this._pickCallback({ longitude, latitude });
            }
        }, ScreenSpaceEventType.LEFT_CLICK);
    }
}